import { render, staticRenderFns } from "./FormEditorPanel.vue?vue&type=template&id=68287464&scoped=true"
import script from "./FormEditorPanel.vue?vue&type=script&lang=js"
export * from "./FormEditorPanel.vue?vue&type=script&lang=js"
import style0 from "./FormEditorPanel.vue?vue&type=style&index=0&id=68287464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68287464",
  null
  
)

export default component.exports